import CyclesContainer from './CyclesContainer';

export default { CyclesContainer };
